export type CareerHeaderContent = {
  careerHeader: {
    headerMenuItems?: Queries.HeaderLevelOneMenuItem[];
    headerSecondaryUpperMenu?: Queries.HeaderSecondaryUpperMenuItem[];
    headerButtonPrimary?: Queries.RedesignButton;
    headerButtonSecondary?: Queries.RedesignButton;
    headerOtherText?: Queries.HeaderOtherText;
  };
};

export type CareerCmsRecord = {
  careerHeaderContent: CareerHeaderContent;
};

type CareerCmsPageQueryData = {
  careerHeaderContent?: {
    nodes: readonly { childGlobalJson: CareerHeaderContent | null }[];
  };
};

export const unwrapCareerCmsRecordFromPageQuery = (data: unknown): CareerCmsRecord => {
  const pageData = data as CareerCmsPageQueryData;

  return {
    careerHeaderContent: pageData.careerHeaderContent!.nodes[0].childGlobalJson!,
  };
};
